import i18next from 'i18next'

export const loadTranslations = async (locale: string): Promise<void> => {
  const translationBackendUrl = process.env.REACT_APP_TRANSLATION_BACKEND_URL
  await fetch(`${translationBackendUrl}locales/${locale}.json`)
    .then((response) => response.json())
    .then((translations) => i18next.addResources(locale, 'translation', translations))
}

export const getCookie = (name: string): string | null => {
  const matches = document.cookie.match(
    // eslint-disable-next-line no-useless-escape
    new RegExp(`(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`),
  )
  return matches ? decodeURIComponent(matches[1]) : null
}
export const setCookie = (name: string, value: string, days?: number): void => {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toUTCString()}`
  }
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`
}

export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
}
